<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1" v-html="question.fields[0].choice"></div>

      <div class="next-steps-button" v-if="ctaShow">
        <br />
        <a
          class="button is-primary submit-button"
          target="_blank"
          :href="ctaUrl"
          >{{ ctaText }}</a
        >
      </div>
      <div v-if="choice && this.question.required">
        <hr />
        <label class="accepted-agreement mb1">
          <input type="checkbox" v-model="choice.acceptedAgreement" />
          <span v-if="question.meta.customAgreementText">{{
            question.meta.customAgreementText
          }}</span>
          <span v-else>I Agree</span>
        </label>

        <div class="name-field" v-if="showNameField">
          <h4 class="mt2 mb1" v-if="question.meta.customAgreementInputLabel">
            {{ question.meta.customAgreementInputLabel }}
          </h4>
          <h4 class="mt2 mb1" v-else>Enter First and Last Name</h4>
          <input class="mb1" type="text" v-model="choice.name" />
        </div>
      </div>

      <div class="mb3" id="signature" v-if="choice && includeSignatureBox">
        <hr />
        <h4 class="mb1">Signature</h4>
        <VueSignaturePad
          :options="{ onEnd: onSignatureEnd }"
          :width="signatureWidth"
          ref="signaturePad"
        />
        <a class="mt1 clear-signature" @click="clearSignature"
          >Clear Signature</a
        >
      </div>
      <next-button
        :id="question.id"
        :choice="choice"
        :hasAnswer="hasAnswer"
        v-if="showNextButton"
      ></next-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import baseQuestion from "./baseQuestion";
import { isBoolean, isObject } from "lodash";
import { stringIsEmpty } from "../../helpers/strings";
export default {
  name: "instruction",

  mixins: [baseQuestion],

  methods: {
    clearSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    onSignatureEnd() {
      this.hasSigned = true;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        let choice = !isObject(this.choice) ? {} : this.choice;
        this.choice = {
          ...choice,
          signature: {
            name: "signature.png",
            data: data,
            type: "text/png"
          }
        };
        this.setSignatureDate();
      }
    },
    setSignatureDate() {
      let choice = !isObject(this.choice) ? {} : this.choice;
      this.choice = {
        ...choice,
        signature_date: Date()
      };
    },
    recordAnswer() {
      let validation = _({
        isValid: true
      })
        .thru(v => {
          if (
            this.includeSignatureBox === true &&
            this.question.required === true &&
            this.hasSigned !== true
          ) {
            return { ...v, isValid: false };
          }
          return v;
        })
        .thru(v => {
          if (
            this.question.required === true &&
            stringIsEmpty(this.choice.name) === true
          ) {
            return { ...v, isValid: false };
          }
          return v;
        })
        .value();

      if (validation.isValid) {
        this.hasAnswer = true;
        this.$store.dispatch("interview/setNext", true);
      } else {
        this.hasAnswer = false;
        this.$store.dispatch("interview/setNext", false);
      }
    }
  },
  watch: {
    choice(_newVal, _oldVal) {
      this.recordAnswer();
    },
    "choice.name": function(_newVal, _oldVal) {
      this.setSignatureDate();
      this.recordAnswer();
    },
    "choice.acceptedAgreement": function(newVal, _oldVal) {
      if (newVal === false) {
        this.choice.name = "";
      }
    }
  },
  computed: {
    showNameField() {
      return this.choice.acceptedAgreement ? true : false;
    },
    signatureWidth() {
      return "500px";
    },
    ctaText() {
      return (this.question.meta || {}).ctaText;
    },
    ctaUrl() {
      return (this.question.meta || {}).ctaUrl;
    },
    ctaShow() {
      let ctaShow = (this.question.meta || {}).ctaShow;
      return isBoolean(ctaShow) ? ctaShow : false;
    },
    showNextButton() {
      let hideNextButton = (this.question.meta || {}).hideNextButton;
      return isBoolean(hideNextButton) ? !hideNextButton : true;
    },
    includeSignatureBox() {
      let includeSignatureBox = (this.question.meta || {}).includeSignatureBox;
      return isBoolean(includeSignatureBox) ? includeSignatureBox : false;
    }
  }
};
</script>

<style lang="scss" scoped>
#signature {
  div {
    -webkit-box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.51);
    -moz-box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.51);
    box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.51);
  }
}
.accepted-agreement {
  text-align: left;
  display: block;
  input {
    margin-right: 5px;
    position: relative;
    top: 3px;
  }
}
.name-field {
  text-align: left;
  input {
    width: 33%;
    @media only screen and (max-width: 725px) {
      width: 100%;
    }
  }
}

#signature > .mb1 + div {
  position: relative;
  height: auto !important;
  max-width: 100%;
}

#signature > .mb1 + div:before {
  width: 100%;
  content: “”;
  height: 0;
  padding-bottom: 50%;
  display: block;
}

#signature > .mb1 + div > canvas {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100% !important;
  height: 100% !important;
}

.clear-signature {
  display: block;
  text-align: left;
}
</style>
